import { useState } from "react";
import { X, Radio } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { startCheckout } from "@/lib/checkout";

export function BundleBanner() {
  const { user } = useAuth();
  const [hidden, setHidden] = useState(() => localStorage.getItem("bundle_banner_dismissed") === "1");
  const show = user && user.business_active && !user.snap_active && user.role !== "admin" && !hidden;
  if (!show) return null;
  const dismiss = () => { localStorage.setItem("bundle_banner_dismissed", "1"); setHidden(true); };
  return (
    <div data-testid="bundle-banner" className="bg-sky-500 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2.5 flex items-center justify-between gap-3 text-sm">
        <span className="flex items-center gap-2">
          <Radio className="w-4 h-4 shrink-0" />
          <span>Add <strong>SnapBudget</strong> to your Business plan for <strong>$9.99/mo</strong> — save $6/mo vs standalone.</span>
        </span>
        <div className="flex items-center gap-3 shrink-0">
          <button data-testid="bundle-add" onClick={() => startCheckout("snapbudget_bundle_monthly").catch(() => {})} className="underline underline-offset-2 hover:opacity-90 whitespace-nowrap">Add it</button>
          <button data-testid="bundle-dismiss" onClick={dismiss} className="opacity-80 hover:opacity-100"><X className="w-4 h-4" /></button>
        </div>
      </div>
    </div>
  );
}
